import { useEffect, useState } from "react";
import { Moon, Sun } from "lucide-react";
import { NAV_LINKS } from "@/data/content";
import { LogoMark } from "@/components/decor";
import { scrollToId } from "@/lib/scroll";

const go = (e, href) => {
  e.preventDefault();
  scrollToId(href);
};

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [dark, setDark] = useState(false);

  useEffect(() => {
    setDark(document.documentElement.classList.contains("dark"));
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const toggleTheme = () => {
    const next = !dark;
    setDark(next);
    document.documentElement.classList.toggle("dark", next);
    try {
      localStorage.setItem("theme", next ? "dark" : "light");
    } catch (e) {}
  };

  return (
    <header
      data-testid="navbar"
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled ? "border-b border-line bg-paper/85 backdrop-blur-xl" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-5 sm:px-8 lg:h-[72px]">
        <a
          href="#home"
          data-testid="nav-logo-link"
          onClick={(e) => go(e, "#home")}
          className="flex items-center gap-2.5"
        >
          <LogoMark className="h-8 w-8" />
          <span className="font-display text-lg font-bold tracking-tight">Infra Digest</span>
        </a>

        <div className="flex items-center gap-8">
          <nav className="hidden items-center gap-8 md:flex" aria-label="Primary">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-link-${l.href.replace("#", "")}`}
                onClick={(e) => go(e, l.href)}
                className="text-sm font-medium text-ink/65 transition-colors hover:text-accent"
              >
                {l.label}
              </a>
            ))}
          </nav>
          <button
            type="button"
            data-testid="theme-toggle-button"
            onClick={toggleTheme}
            aria-label={dark ? "Switch to light mode" : "Switch to dark mode"}
            className="rounded-lg border border-line bg-paper/60 p-2 text-ink backdrop-blur transition-colors duration-300 hover:border-accent hover:text-accent"
          >
            {dark ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
          </button>
        </div>
      </div>
    </header>
  );
}
